/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DjRestAuthUser } from '../models/DjRestAuthUser';
import type { GoogleSocialLogin } from '../models/GoogleSocialLogin';
import type { Login } from '../models/Login';
import type { PasswordChange } from '../models/PasswordChange';
import type { PasswordReset } from '../models/PasswordReset';
import type { PasswordResetConfirm } from '../models/PasswordResetConfirm';
import type { PatchedUserDetail } from '../models/PatchedUserDetail';
import type { ResendEmailVerification } from '../models/ResendEmailVerification';
import type { RestAuthDetail } from '../models/RestAuthDetail';
import type { UserCompleteRegistration } from '../models/UserCompleteRegistration';
import type { UserDetail } from '../models/UserDetail';
import type { UserPendingNotifications } from '../models/UserPendingNotifications';
import type { UserRegistration } from '../models/UserRegistration';
import type { VerifyEmail } from '../models/VerifyEmail';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AuthService {

    /**
     * @returns RestAuthDetail
     * @throws ApiError
     */
    public static authAccountConfirmEmailCreate({
        requestBody,
    }: {
        requestBody: VerifyEmail,
    }): CancelablePromise<RestAuthDetail> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/account-confirm-email/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Custom login view with request logging
     * @returns Login
     * @throws ApiError
     */
    public static authLoginCreate({
        requestBody,
    }: {
        requestBody: Login,
    }): CancelablePromise<Login> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/login/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Calls Django logout method and delete the Token object
     * assigned to the current User object.
     *
     * Accepts/Returns nothing.
     * @returns RestAuthDetail
     * @throws ApiError
     */
    public static authLogoutCreate(): CancelablePromise<RestAuthDetail> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/logout/',
        });
    }

    /**
     * Calls Django Auth SetPasswordForm save method.
     *
     * Accepts the following POST parameters: new_password1, new_password2
     * Returns the success/fail message.
     * @returns RestAuthDetail
     * @throws ApiError
     */
    public static authPasswordChangeCreate({
        requestBody,
    }: {
        requestBody: PasswordChange,
    }): CancelablePromise<RestAuthDetail> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/password/change/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Calls Django Auth PasswordResetForm save method.
     *
     * Accepts the following POST parameters: email
     * Returns the success/fail message.
     * @returns RestAuthDetail
     * @throws ApiError
     */
    public static authPasswordResetCreate({
        requestBody,
    }: {
        requestBody: PasswordReset,
    }): CancelablePromise<RestAuthDetail> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/password/reset/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Password reset e-mail link is confirmed, therefore
     * this resets the user's password.
     *
     * Accepts the following POST parameters: token, uid,
     * new_password1, new_password2
     * Returns the success/fail message.
     * @returns RestAuthDetail
     * @throws ApiError
     */
    public static authPasswordResetConfirmCreate({
        requestBody,
    }: {
        requestBody: PasswordResetConfirm,
    }): CancelablePromise<RestAuthDetail> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/password/reset/confirm/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Returns provider profile metadata (source_type, profile_disposition, has_usable_password)
     * for a given password reset uid+token. Used by the frontend to determine post-reset redirect.
     * Validates the token so only holders of a valid reset link can query this info.
     * @returns any No response body
     * @throws ApiError
     */
    public static authPasswordResetProviderInfoRetrieve({
        token,
        uid,
    }: {
        token: string,
        uid: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/auth/password/reset/provider-info/',
            query: {
                'token': token,
                'uid': uid,
            },
        });
    }

    /**
     * Extends the default RegisterView to handle HCO-sourced providers completing
     * their account via the standard signup form.  Those users already have a
     * verified EmailAddress created by the inviting organisation, so we skip the
     * email verification gate and log them straight in.
     * @returns UserRegistration
     * @throws ApiError
     */
    public static authRegistrationCreate({
        requestBody,
    }: {
        requestBody: UserRegistration,
    }): CancelablePromise<UserRegistration> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/registration/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns UserCompleteRegistration
     * @throws ApiError
     */
    public static authRegistrationCompleteUpdate({
        requestBody,
    }: {
        requestBody: UserCompleteRegistration,
    }): CancelablePromise<UserCompleteRegistration> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/auth/registration/complete',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns RestAuthDetail
     * @throws ApiError
     */
    public static authRegistrationResendEmailCreate({
        requestBody,
    }: {
        requestBody: ResendEmailVerification,
    }): CancelablePromise<RestAuthDetail> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/registration/resend-email/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns RestAuthDetail
     * @throws ApiError
     */
    public static authRegistrationVerifyEmailCreate({
        requestBody,
    }: {
        requestBody: VerifyEmail,
    }): CancelablePromise<RestAuthDetail> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/registration/verify-email/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * class used for social authentications
     * example usage for facebook with access_token
     * -------------
     * from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter
     *
     * class FacebookLogin(SocialLoginView):
     * adapter_class = FacebookOAuth2Adapter
     * -------------
     *
     * example usage for facebook with code
     *
     * -------------
     * from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter
     * from allauth.socialaccount.providers.oauth2.client import OAuth2Client
     *
     * class FacebookLogin(SocialLoginView):
     * adapter_class = FacebookOAuth2Adapter
     * client_class = OAuth2Client
     * callback_url = 'localhost:8000'
     * -------------
     * @returns DjRestAuthUser
     * @throws ApiError
     */
    public static authSocialLoginGoogleCreate({
        requestBody,
    }: {
        requestBody?: GoogleSocialLogin,
    }): CancelablePromise<DjRestAuthUser> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/social-login/google/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns UserDetail
     * @throws ApiError
     */
    public static authUserRetrieve(): CancelablePromise<UserDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/auth/user/',
        });
    }

    /**
     * @returns UserDetail
     * @throws ApiError
     */
    public static authUserUpdate({
        requestBody,
    }: {
        requestBody: UserDetail,
    }): CancelablePromise<UserDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/auth/user/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns UserDetail
     * @throws ApiError
     */
    public static authUserPartialUpdate({
        requestBody,
    }: {
        requestBody?: PatchedUserDetail,
    }): CancelablePromise<UserDetail> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/auth/user/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static authUserDestroy(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/auth/user/',
        });
    }

    /**
     * @returns UserPendingNotifications
     * @throws ApiError
     */
    public static authUserNotificationsRetrieve(): CancelablePromise<UserPendingNotifications> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/auth/user/notifications',
        });
    }

}
